var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.961 9.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        fill: #037a61;\n      }\n\n      .c {\n        fill: #32d74b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M4.9805,9.9609c2.749,0,4.9805-2.2363,4.9805-4.9805-.0001-2.7489-2.2315-4.9804-4.9805-4.9804C2.2363,0,0,2.2315,0,4.9805c0,2.7441,2.2363,4.9805,4.9805,4.9805h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.3288,4.7706l3.4325-3.4325.2889,3.3026c.0209.2395-.1794.4398-.4188.4188l-3.3026-.2889Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.6322,5.1904l-3.4325,3.4325-.2889-3.3026c-.0209-.2395.1794-.4398.4188-.4188l3.3026.2889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalize);
export default __webpack_public_path__ + "static/media/normalize.dc3749311b670adde0e4854a4c87ee44.svg";
export { ForwardRef as ReactComponent };